const STORAGE_KEY = "xpro_advanced_search_shortcut_hint_dismissed";

export function isAdvancedSearchShortcutHintDismissed() {
  try {
    return localStorage.getItem(STORAGE_KEY) === "1";
  } catch {
    return false;
  }
}

export function dismissAdvancedSearchShortcutHint() {
  try {
    localStorage.setItem(STORAGE_KEY, "1");
  } catch {
    /* ignore */
  }
}

export function getAdvancedSearchShortcutLabel() {
  if (typeof navigator === "undefined") return "Ctrl+F";
  const ua = String(navigator.userAgent || "");
  const platform = String(navigator.platform || "");
  if (/Mac|iPhone|iPod|iPad/i.test(platform) || /Mac OS|iPhone|iPad/i.test(ua)) {
    return "⌘F";
  }
  return "Ctrl+F";
}
